import * as MarketingContent from '../services/api/requests/MarketingContents'
import getSelectedMallSlug from '../services/getSelectedMallSlug'

// data
const DASHBOARD_TOP_PICKS = { title: 'Top Picks' }
const DASHBOARD_WHATS_ON = {
  title: "What's On?",
  description: 'Check out events and happenings at Ayala Malls.',
}
const DASHBOARD_BEST_DEALS = {
  title: 'Best Deals',
  description: 'Discover limited-time offers at Ayala Malls.',
}

// section titles and descriptions
export const doGetPromosEventsSections = () => {
  return {
    event: DASHBOARD_WHATS_ON,
    promo: DASHBOARD_BEST_DEALS,
    featured: DASHBOARD_TOP_PICKS,
  }
}

export const doGetFeaturedMarketingContent = ({
  setFeatured,
  onSuccess,
  onError,
}) => async (limit, appearance) => {
  const mallSlug = getSelectedMallSlug()
  MarketingContent.getFeatured(mallSlug, limit, appearance)
    .then(response => {
      if (setFeatured) setFeatured(response.data)
      if (onSuccess) onSuccess()
    })
    .catch(error => {
      if (onError) onError(error)
    })
}

export const doGetWhatsOn = ({
  setWhatsOn,
  onSuccess,
  onError,
}) => async limit => {
  const mallSlug = getSelectedMallSlug()
  MarketingContent.getWhatsOn(mallSlug, limit)
    .then(response => {
      if (setWhatsOn) setWhatsOn(response.data)
      if (onSuccess) onSuccess(response.data)
    })
    .catch(error => {
      if (onError) onError(error)
    })
}

export const doGetBestDeals = ({
  setBestDeals,
  onSuccess,
  onError,
}) => async limit => {
  const mallSlug = getSelectedMallSlug()
  MarketingContent.getBestDeals(mallSlug, limit)
    .then(response => {
      if (setBestDeals) setBestDeals(response.data)
      if (onSuccess) onSuccess(response.data)
    })
    .catch(error => {
      if (onError) onError(error)
    })
}

export const doGetMarketingContent = ({
  setMarketingContent,
  onSuccess,
  onError,
}) => async id => {
  MarketingContent.getMarketingContent(id)
    .then(response => {
      const { data } = response
      if (setMarketingContent)
        setMarketingContent({
          ...data,
          body: data.body.replace(/<a href="(.+?)"/g, (_, url) => {
            const isAbsolute =
              url.startsWith('http://') || url.startsWith('https://')
            const theUrl = isAbsolute ? url : `http://${url}`
            return `<a href="${theUrl}" target="_blank"`
          }),
        })
      if (onSuccess) onSuccess()
    })
    .catch(error => {
      if (onError) onError(error)
    })
}

export const doGetRelatedArticles = ({
  setRelatedArticles,
  onSuccess,
  onError,
}) => async id => {
  MarketingContent.getRelatedArticles(id)
    .then(response => {
      if (setRelatedArticles) setRelatedArticles(response.data)
      if (onSuccess) onSuccess()
    })
    .catch(error => {
      if (onError) onError(error)
    })
}

// ST-1384
export const doGetMarketingContentDetails = async ({ id }) => {
  try {
    const response = await MarketingContent.getMarketingContent(id)
    return response.data
  } catch (e) {
    return false
  }
}
